module.exports = __webpack_public_path__ + "img/qualification_7.950b90ba.png";